import { render, staticRenderFns } from "./ConsoleAccount.vue?vue&type=template&id=89a0cbba&scoped=true"
import script from "./ConsoleAccount.vue?vue&type=script&lang=js"
export * from "./ConsoleAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89a0cbba",
  null
  
)

export default component.exports